import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import desktop from '@/apps/desktop/router';
import mobile from '@/apps/mobile/router';
import kiosk from '@/apps/kiosk/router';
import auth from '@/apps/auth/router';
import configurator from '@/apps/configurator/router';
import cart from '@/apps/cart/router';
import {
  CART_EXPAND,
  ORDER_SET_RESTAURANT,
  ORDER_SET_TERMINAL,
  SHOW_CHECKOUT_DIALOG,
} from '@/apps/cart/store/types';
import { API_ERROR_SET } from '@/apps/core/store/types';
import { AUTH_LOGOUT } from '@/apps/auth/store/types';

Vue.use(Router);

const topPoint = { x: 0, y: 0 };

const webRouter = new Router({
  routes: [
    ...desktop,
    ...configurator,
    ...cart,
    ...auth,
    {
      path:     '*',
      redirect: '/',
    },
  ],
  /**
   * Open new route always at the top
   */
  scrollBehavior() {
    return topPoint;
  },
});

const mobileRouter = new Router({
  routes: [
    ...mobile,
    {
      path:     '*',
      redirect: '/',
    },
  ],
  /**
   * Open new route always at the top
   */
  scrollBehavior() {
    return topPoint;
  },
});

const kioskRouter = new Router({
  routes: [
    ...kiosk,
    {
      path:     '*',
      redirect: '/',
    },
  ],
  /**
   * Open new route always at the top
   */
  scrollBehavior() {
    return topPoint;
  },
});

/**
 * Web router guard.
 */
webRouter.beforeEach((to, from, next) => {
  /* Redirect to main if not set restaurantId */
  if (!store.getters.restaurantId) {
    if (to.name !== 'restaurant-picker' && to.name !== 'main' && to.name !== 'reset-password') {
      next({ name: 'main' });

      return;
    }
  }
  next();
});

/**
 * Check the value of the restaurant id and terminal id, and if necessary, update it.
 */
kioskRouter.beforeEach((to, from, next) => {
  const queryRestaurantId = to.query.restaurantId;
  const queryTerminalId = to.query.terminalId;
  let newValue = null;

  if (queryRestaurantId) {
    newValue = queryRestaurantId;
  }

  if (newValue) {
    store.dispatch(ORDER_SET_RESTAURANT, newValue);
  }

  if (queryTerminalId) {
    store.dispatch(ORDER_SET_TERMINAL, queryTerminalId);
  }

  const terminalIdChanged = store.getters.terminalId && queryTerminalId &&
    store.getters.terminalId !== queryTerminalId;
  const restaurantIdChanged = store.getters.restaurantId && queryTerminalId &&
    store.getters.restaurantId !== queryTerminalId;

  if (terminalIdChanged || restaurantIdChanged) {
    store.dispatch(AUTH_LOGOUT);
  }

  /* Error msg if not set restaurantId */
  if (!store.getters.restaurantId) {
    store.dispatch(API_ERROR_SET, {
      detail: 'restaurantId is not defined',
    });
  }

  /* Error msg if not set terminalId */
  if (!store.getters.terminalId) {
    store.dispatch(API_ERROR_SET, {
      detail: 'terminal is not defined',
    });
  }


  next();
});

mobileRouter.afterEach((to) => {
  if (String(to.query.cart) === 'true') {
    store.dispatch(CART_EXPAND);
  }

  if (String(to.query.loginSuggest) === 'true') {
    store.dispatch(SHOW_CHECKOUT_DIALOG);
  }
});

export default {
  webRouter,
  mobileRouter,
  kioskRouter,
};



// WEBPACK FOOTER //
// ./src/router/index.js